module.exports = __webpack_public_path__ + "img/punctedelucru-o.8201e268.svg";